"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.someKey = void 0;
function someKey(subject, predicate, thisArg) {
    return Object.keys(subject).some(function (k, i, a) {
        return predicate.apply(this, [k, i, a, subject]);
    }, thisArg);
}
exports.someKey = someKey;
//# sourceMappingURL=someKey.js.map